import { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import styled from "styled-components";
import { Empty, SpinLoading } from "antd-mobile";
import useNavigation from "../../hooks/useNavigation";
import PageWrap from "../components/PageWrap";
import PageHeader, { headerHeight } from "../components/PageHeader";
import { useStores } from "../../models";
import { ToastError } from "../../components/Toast";
import { ComplaintCard } from "../../components/Wallet";
import { TakeOrderData } from "../../proto/nbchat-proto";
import useGlobalTheme from "../../hooks/useGlobalTheme";

const tabs = [
  { id: -1, text: "全部" },
  { id: 0, text: "已处理" },
  { id: 1, text: "未处理" },
];

const Body = styled.div`
  height: calc(100% - ${headerHeight});
  display: flex;
  flex-direction: column;
  min-height: 0;
  background: #f7f8ff;
`;

const Tabs = styled.div`
  flex-shrink: 0;
  display: flex;
  height: 40px;
  background: #fff;
`;

const Tab = styled.div<{ $active?: boolean }>`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 14px;
  font-weight: ${({ $active }) => ($active ? 600 : 400)};
  color: ${({ $active, theme }) =>
    $active ? theme.colors.primary : theme.colors.secondaryText || "#999"};
`;

const ScrollArea = styled.div`
  flex: 1;
  min-height: 0;
  overflow: auto;
`;

const MyComplaint = () => {
  const theme = useGlobalTheme();
  const { navigate } = useNavigation();
  const { walletStore } = useStores();
  const [loading, setLoading] = useState(true);
  const [list, setList] = useState<TakeOrderData[]>([]);
  const [complaintStatus, setComplaintStatus] = useState<number>(-1);

  const load = async () => {
    try {
      setLoading(true);
      const filters: Record<string, any> = {
        current: 1,
        pageSize: 30,
      };
      if (complaintStatus === 0) {
        filters.status_in = [11, 12];
      } else if (complaintStatus === 1) {
        filters.status_in = [10];
      } else {
        filters.status_in = [10, 11, 12];
      }
      const res = await walletStore.getTakeOrdersDisputed(filters);
      const next = Array.isArray(res) ? res : res?.data || [];
      setList(next);
    } catch (e: any) {
      ToastError(e.message || "加载失败");
      setList([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [complaintStatus]);

  return (
    <PageWrap>
      <PageHeader title="我的申诉" />
      <Body>
        <Tabs>
          {tabs.map((tab) => (
            <Tab
              key={tab.id}
              $active={complaintStatus === tab.id}
              onClick={() => setComplaintStatus(tab.id)}
            >
              {tab.text}
            </Tab>
          ))}
        </Tabs>
        <ScrollArea>
          {loading ? (
            <div
              style={{ display: "flex", justifyContent: "center", padding: 40 }}
            >
              <SpinLoading color={theme.colors.primary} />
            </div>
          ) : list.length === 0 ? (
            <Empty description="暂无数据" style={{ padding: 40 }} />
          ) : (
            list.map((order) => (
              <ComplaintCard
                key={order.trans_no}
                order={order}
                onClick={() =>
                  navigate("MyComplaintDetail", {
                    id: order.trans_no,
                    order,
                  })
                }
              />
            ))
          )}
        </ScrollArea>
      </Body>
    </PageWrap>
  );
};

export default observer(MyComplaint);
